import { render, staticRenderFns } from "./patientPageChildren.vue?vue&type=template&id=075de22b&scoped=true"
import script from "./patientPageChildren.vue?vue&type=script&lang=js"
export * from "./patientPageChildren.vue?vue&type=script&lang=js"
import style0 from "./patientPageChildren.vue?vue&type=style&index=0&id=075de22b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075de22b",
  null
  
)

export default component.exports